<template lang="">
    <div class="joblistings default-section" ref="jobListingsContainer">
        <div class="listings-heading" v-show="!showInitContent">
            <span>{{title}}</span> <span v-if="total" class="total">{{formatCount(total)}}</span>
        </div>
        <div class="jobs-display">
          <div class="for-collection">
            <div class="collection" v-show="!showInitContent">
                <JobListItem ref="listItem" v-for="(job, index) in collection"
                  
                  :key="index"
                  :job="job" :openModal="() => openModal(index)"/>

              <!-- Pagination -->
              <div class="paginations" v-show="!showInitContent && (jobs.length >= 10)">
                  <div class="btn btn-default"
                  v-if="isLoadingMore" 
                    style="border:0px;color:var(--page-header)!important;"
                    disabled>{{pageButtonLabel}}</div>

                  <button
                  class="btn btn-default load-more"
                  @click="nextPage"
                  v-else>
                  {{pageButtonLabel}}
                </button>       
              </div>
            <!-- Pagination -->
            </div>
          
        </div>
        <!-- Preview to see job details -->
            <div class="job-preview" v-show="!showInitContent">
                <JobPreview :job="preview" :update-job-is-saved-status="updateJobIsSavedStatus" />
            </div>
        </div>
        
    </div>
    <!-- preview modal -->
<VacancyPreviewModal ref="vacPreviewModal"
                    v-show="!showInitContent"
                    :update-job-is-saved-status="updateJobIsSavedStatus"
                    :hide-vacancy-preview="hideVacancyPreview"
                    :job="preview"/>
</template>
<script>

    import JobListItem from './JobListItem.vue';
    import JobPreview from './JobPreview.vue';
    import { Modal } from 'bootstrap';
    import VacancyPreviewModal from '../modals/VacancyPreviewModal.vue';
    import pagecontent from '../../assets/text.json'


export default {
  components:{
     VacancyPreviewModal
  },
    props:{
        title: String,
        jobs: Array,
        getPageAsync: Function,
        initLoading: Boolean,
        initLoadingError: Boolean,
        resetPagination: { //resets pagination when modes are switched
                    type: Function,
                    required: false
                  },
        total: {
          type: Number,
          required: false
        }
    },
    created(){
      //onCreatedSearchAsync has to run when component is created
      // if (typeof this.onCreatedSearchAsync === 'function') {
      // this.onCreatedSearchAsync();
      // }
    },
    data(){
        return{   
          pagecontent, 
            // pageNumber: 0,    
            preview: {
              id:'',
              name:'',
              handle:'',
              jobId:'',
              jobTitle:'',
              location:'',
              closingDate:'',
              description:'',
              jobType:'',
              isSaved: null,
              encodedJobId:'',
            },
            showInitContent: true, //keep as true
            collection: [],
            modalInstance:null,
            pageButtonLabel: "Load More",
            isLoadingMore: false
        }
    },
    mounted(){
      
    },
   watch:{
      getPageAsync:{ //check which function is being used. A search function or a normal listing function
        handler(newValue, oldValue){
           if(typeof newValue === 'function' && 
              typeof oldValue === 'function' &&
              typeof this.resetPagination == 'function') {
             
                this.resetPagination(); //reset pagination
                this.getPageAsync();     
            }
        }
      },
      jobs:{
        handler(newValue, oldValue){
          if (!Array.isArray(newValue)) {
            return;
          }

          if (!Array.isArray(oldValue) || oldValue.length === 0){ // if theres initially nothing in the list
            if (newValue.length > 0) {
              this.setFirstRecordOnLoad(newValue[0]); // then set the first value in collection
            }
            this.collection = [...newValue];
            return;
          }

          if (newValue !== oldValue){
            const mergedJobMap = new Map();

            this.collection.forEach(job => {
              if (job && job.jobId) {
                mergedJobMap.set(job.jobId, {...job});
              }
            });

            newValue.forEach(job => {
              if (job && job.jobId) {
                mergedJobMap.set(job.jobId, {
                  ...mergedJobMap.get(job.jobId),
                  ...job
                });
              }
            });

            this.collection = Array.from(mergedJobMap.values());
          }
        },
        deep: true,
        immediate: false
      },
      initLoading:{
        handler(newValue){
          this.showInitContent = newValue;
        },
        immediate: false
      },
      initLoadingError:{
        handler(newValue){
          if(newValue == true){
            this.showInitContent = true;
          }
        },
        immediate: false
      }

    },
    components:{
        JobListItem, JobPreview, VacancyPreviewModal
    },
    methods:{
        updateJobIsSavedStatus(jobItem, isSaved){
            jobItem.isSaved = isSaved;
            const jobIndex = this.collection.findIndex(item => item.jobId === jobItem.jobId);
            if (jobIndex !== -1) {
                this.collection[jobIndex] = {
                    ...this.collection[jobIndex],
                    ...jobItem
                };
            }
        },
        setFirstRecordOnLoad(job){
             this.preview.id = job.company.id;
             this.preview.name = job.company.name;
             this.preview.handle = job.company.handle;
             this.preview.jobId = job.jobId;
             this.preview.jobTitle = job.jobTitle;
             this.preview.location = job.location;
             this.preview.closingDate = job.closingDate;
             this.preview.description = job.description;
             this.preview.jobType = job.jobType;
             this.preview.isSaved = job.isSaved;
             this.preview.encodedJobId = job.encodedJobId;
        },
        openModal(index){
              let job = this.$refs.listItem[index].getListItem();
             this.preview.id = job.company.id;
             this.preview.name = job.company.name;
             this.preview.handle = job.company.handle;
             this.preview.jobId = job.jobId;
             this.preview.jobTitle = job.jobTitle;
             this.preview.location = job.location;
             this.preview.closingDate = job.closingDate;
             this.preview.description = job.description;
             this.preview.jobType = job.jobType;
             this.preview.isSaved = job.isSaved;
             this.preview.encodedJobId = job.encodedJobId;
            if (window.innerWidth <= 768) {
              this.$refs.vacPreviewModal.show();
            }else{
               this.$refs.jobListingsContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
               
            }
        },
        setButtonToLoadingMore(){
          this.pageButtonLabel = "Getting More...",
          this.isLoadingMore = true;
        },
        setButtonToLoadingError(){
          this.pageButtonLabel = this.pagecontent.jobListings.loadMoreMessage,
          this.isLoadingMore = false;
        },
        setButtonToSuccessfulLoad(){
          this.pageButtonLabel = "Load More";
          this.isLoadingMore = false;
          //this.pageNumber -= 1; //stay on previous page number if next page fails to load
        },
        nextPage(){
          this.getPageAsync();
        },
        hideVacancyPreview(){
          this.$refs.vacPreviewModal.hide();
        },
        formatCount(value) {
          return new Intl.NumberFormat().format(value);
        },
        getProfileJobListingsPageAsync(){
            if(typeof this.getPageAsync === 'function'){
                this.getPageAsync();
            }
        }

    }
}
</script>
<style scoped>

.total{
  color:var(--placeholder);
}

.listings-heading{
  margin: 0.9rem 0rem;
  color: var(--page-header);
  font-family:var(--page-header-font);
  font-size: 0.9rem;
}

.load-more{
  color:var(--page-header);
  background:var(--list-item);
  width:100%;
  border:0px;
  min-height:2rem;
}

.modal-title{
  color:var(--primary);
}

.jobs-display {
  display: flex;
  column-gap: 0.5rem;
}

.page-link{
    color:var(--primary);
}

.modal-body{
    max-height: 500px;
    overflow-y: auto;        /* vertical scroll */
    overflow-x: hidden; 
    scrollbar-width: thin; 
    scrollbar-color: var(--scrollbar-color) var(--nav);
    margin-bottom:1.4rem;
}

.collection {
  flex: 1;
  max-height: 700px;       /* desktop/tablet: scrollable */
  overflow-y: auto;        /* vertical scroll */
  overflow-x: hidden;      /* disable horizontal scroll */
  padding-right: 0.5rem;   /* space so scrollbar doesn’t overlap content */
/* 
  scrollbar-width: thin; 
  scrollbar-color: rgb(122, 122, 122) #f0f0f0; */
}

.modal{
    margin-top:0.9rem;
}

.modal-body{
    padding:0;
}

.for-collection{
  flex: 0.8;
  display:flex;
  flex-direction:column;
}

.job-preview {
  flex: 1;
  max-height:700px;
  overflow-y: scroll;
  overflow-x: hidden;
}


.job-preview::-webkit-scrollbar {
  width: 8.5px;
}

.job-preview::-webkit-scrollbar-track {
  background: var(--list-item);
  border-radius: 4px;
  border:0px;
}

.job-preview::-webkit-scrollbar-thumb {
  background-color: var(--job-listings-scroll-bar-color);
  border-radius: 4px;
  border: 2px solid var(--list-item);
}

.job-preview::-webkit-scrollbar-thumb:hover {
  background-color: var(--scrollbar-color);
}


/* Custom vertical scrollbar for WebKit browsers (Chrome, Edge, Safari) */
.collection::-webkit-scrollbar {
  width: 8.5px;
}

.collection::-webkit-scrollbar-track {
  background: var(--list-item);
  border-radius: 4px;
}

.collection::-webkit-scrollbar-thumb {
  background-color: var(--job-listings-scroll-bar-color);
  border-radius: 4px;
  border: 2px solid var(--list-item);
}

.collection::-webkit-scrollbar-thumb:hover {
  background-color: var(--scrollbar-color);
}




.paginations{
    display:flex;
    justify-content: center;
    align-items: flex-start;
    
}

/* Mobile overrides */
@media (max-width: 768px) {

.for-collection{
  flex: 1;
}

  .job-preview {
    display: none;
  }

  .collection {
    max-height: none;       /* remove height restriction */
    overflow-y: visible;    /* disable vertical scrolling */
    -ms-overflow-style: none;  /* hide scrollbar IE/Edge */
    scrollbar-width: none;     /* hide scrollbar Firefox */
    padding-right: 0rem;   /* space so scrollbar doesn’t overlap content */
  }

  .collection::-webkit-scrollbar {
    display: none;          /* hide scrollbar Chrome/Safari */
  }

  .listings-heading{
      margin:0.9rem 0rem;
      color: var(--page-header); 
      font-size: 1rem;
      font-weight: bold;
       font-family:var(--heading-font2-regular);
    }

 
}
</style>